import { webconfigList } from "../network/home"

export default {
    // acionchange(context, payload) {
    //     setTimeout(() => {
    //         context.commit("actionChange", payload)
    //     }, 500)
    // }
    acionchange({commit},payload) {
        new Promise((resolve,reject)=>{
            setTimeout(() => {
                commit("actionChange", payload)
                resolve("执行完毕！")
            }, 500)
    
        })
    },
    getWebConfig({state, commit}) {
        return new Promise((resolve, reject) => {
            webconfigList().then(res => {
                // console.log('res: ', res)
                const { liveShow, liveImage, liveTitle, liveUrl } = state.webConfig
                const tempLiveShow = res.find((i) => i.code === liveShow.code) || liveShow
                const tempLiveImage = res.find((i) => i.code === liveImage.code) || liveImage
                const tempLiveUrl = res.find((i) => i.code === liveUrl.code) || liveUrl
                const tempLiveTitle = res.find((i) => i.code === liveTitle.code) || liveTitle
                let config = {
                    liveShow: tempLiveShow,
                    liveImage: tempLiveImage,
                    liveUrl: tempLiveUrl,
                    liveTitle: tempLiveTitle
                }
                commit('setWebConfig', config)
                resolve(config)
            }).catch(err => {
                reject(err)
            })
        })
    }
}